import InputNumeric from './InputNumeric';

const formatTimeComponent = (
  timeComponent: string,
  maxValue: number,
  shouldPad: (component: string) => boolean = () => false
) => {
  let component = timeComponent;
  if (shouldPad(component)) {
    component = `0${component}`;
  }
  if (component.length === 2 && +component > maxValue) {
    component = component.slice(0, 1);
  }
  return component;
};

const format = (value: string) => {
  const hours = formatTimeComponent(
    value.slice(0, 2),
    23,
    (hr) => hr.length === 1 && +hr > 2
  );
  const minutes = formatTimeComponent(
    value.slice(2, 4),
    59,
    (min) => min.length === 1 && +min > 5
  );
  const separator = hours.length === 2 ? ':' : '';
  return `${hours}${separator}${minutes}`;
};

export type TimeInputProps = {
  onChange?: (time: { hour: string; minute: string }) => void;
  placeholder?: string;
  defaultValue?: string;
};

export const TimeInput = ({ onChange, ...rest }: TimeInputProps) => (
  <InputNumeric
    onChange={(value) => {
      const hour = value.slice(0, 2);
      const minute = value.slice(2, 4);
      onChange?.({ hour, minute });
    }}
    {...rest}
    format={format}
    max={2359}
  />
);

export default TimeInput;
